import { FC } from "react";
import { Modal, ModalProps, Paragraph, Stack, TextLink } from "@contentful/f36-components";
import { ExternalLinkIcon } from "@contentful/f36-icons";

export const FormalityHelpModal: FC<Pick<ModalProps, "isShown" | "onClose">> = props => {
    return (
        <Modal title="About formality" size="large" {...props}>
            <Stack flexDirection="column" alignItems="start" spacing="spacingS">
                <Paragraph>
                    The formality feature allows you to specify the tone you want to achieve for
                    your translation with the options of a more <strong>formal</strong> or{" "}
                    <strong>informal</strong> tone. The default option <strong>Automatic</strong>{" "}
                    chooses based on the detected formality of the source text.
                </Paragraph>
                <Paragraph>
                    Formality is only available for some languages. These include but are not
                    limited to:
                    <br />
                    <i>
                        German, French, Italian, Spanish, Dutch, Polish, Portuguese, Japanese and
                        Russian
                    </i>
                    .<br /> When you translate into a language that does not support formality,
                    Linguiny will just fall back to a default translation.
                </Paragraph>
                <Paragraph>
                    You can set your preferred formality here in the configuration screen. After
                    saving, this value will always be pre-selected for you. You can also overwrite
                    the formality in the options of a given translation.
                </Paragraph>
                <TextLink
                    href="https://support.deepl.com/hc/articles/4406432463762-About-the-formality-feature"
                    target="_blank"
                    rel="noopener noreferrer"
                    icon={<ExternalLinkIcon />}
                    alignIcon="end">
                    More about formality
                </TextLink>
            </Stack>
        </Modal>
    );
};
